export default {
  namespaced: true,
  state: {
    condition: {},
    sortRule: {},
    excludedItems: [],
    isSimple: false,
    visible: {
      geometry: true,
      label: true,
    },
  },
  persistentStates: [
    'condition',
    'sortRule',
    'excludedItems',
    'isSimple',
    'visible',
  ],
  getters: {
    /**
     * 絞り込み条件
     * @type {Object}
     */
    condition: (state) => state.condition,
    /**
     * ソートルール
     * @type {Object}
     */
    sortRule: (state) => state.sortRule,
    /**
     * 非表示追加項目
     * @type {String[]}
     */
    excludedItems: (state) => state.excludedItems,
    /**
     * カード簡易表示フラグ
     * @type {Boolean}
     */
    isSimple: (state) => state.isSimple,
    /**
     * ユーザーレイヤー表示状態
     * @type {Object}
     */
    visible: (state) => state.visible,
  },
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      state.condition = {}
      state.sortRule = {}
      state.excludedItems = []
      state.isSimple = false
      state.visible = {
        geometry: true,
        label: true,
      }
    },
    /**
     * 絞り込み条件を設定する
     * @param {*} state
     * @param {Object} condition 絞り込み条件
     */
    setCondition(state, condition) {
      state.condition = condition
    },
    /**
     * ソートルールを設定する
     * @param {*} state
     * @param {Object} sortRule ソートルール
     */
    setSortRule(state, sortRule) {
      state.sortRule = sortRule
    },
    /**
     * 非表示追加項目を設定する
     * @param {*} state
     * @param {String[]} items 表示追加項目
     */
    setExcludedItems(state, items) {
      state.excludedItems = items
    },
    /**
     * カード簡易表示フラグを設定する
     * @param {*} state
     * @param {Boolean} isSimple カード簡易表示フラグ
     */
    setIsSimple(state, isSimple) {
      state.isSimple = isSimple
    },
    /**
     * レイヤー表示状態を設定する
     * @param {*} state
     * @param {Object} visible
     */
    setVisible(state, visible) {
      state.visible = visible
    },
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * レイヤー表示状態更新
     */
    setVisible({ commit }, visible) {
      commit('setVisible', visible)
    },
  },
}
